import { useMutation, useQueryClient } from 'react-query';

import { postV2ApiOrganisationIdSettingsMigrate } from 'src/client/spendesk-api';
import { useOrganisationId } from 'src/core/modules/app/hooks/useOrganisationId';

type MigrateToCrossEntityCostCenterData = {
  type: 'costCenter';
  existingEntity: {
    id: string;
    companyId: string;
  };
  autoAssignFutureEntities?: boolean;
  companyIds: string[];
};

const migrateToCrossEntityCostCenter = async (
  organisationId: string,
  data: MigrateToCrossEntityCostCenterData,
): Promise<void> => {
  const response = await postV2ApiOrganisationIdSettingsMigrate({
    path: {
      organisationId,
    },
    body: {
      autoAssignFutureEntities: data.autoAssignFutureEntities,
      existingEntity: data.existingEntity,
      companyIds: data.companyIds,
      type: 'costCenter',
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to create cost center');
  }
};

export const useMigrateToCrossEntityCostCenter = () => {
  const organisationId = useOrganisationId();
  const queryClient = useQueryClient();

  return useMutation(
    (data: MigrateToCrossEntityCostCenterData) =>
      migrateToCrossEntityCostCenter(organisationId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['settings', organisationId]);
      },
    },
  );
};
